<template>
  <div class="header">
    <img src="@/assets/logo1.png"/>
    <div :class="[clickMenu?'img-div2':'img-div']" @click="showMenu"><img src="@/assets/menu.png"/></div>
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  data() {
    return {
      clickMenu: false
    }
  },
  methods: {
    showMenu() {
      this.clickMenu = !this.clickMenu
      this.$emit('showMenu', {type: 1})
    }
  }
}
</script>
<style scoped lang="scss">
.header {
    z-index: 14;
    width: 100%;
    height:120px;
    background:rgba(0, 0, 0, 0.5);
    padding: 21px 40px;
    display: flex;
    justify-content:space-between;
    align-items: center;
    position: relative;
    img {
      width: 217px;
      height: 78px;
    }
    .img-div {
      width:88px;
      height:82px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width:48px;
        height:42px;
      }
    }
    .img-div2 {
      background:#010b21;
      border:1px solid;
      border-color:#ffffff;
      border-radius:7px;
      width:88px;
      height:82px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width:48px;
        height:42px;
      }
    }
    .project-div {
      width:540px;
      height:1800px;
      background:#010b21;
      position: absolute;
      right: 0;
      top: 120px;
      .project-list {
        width: 100%;
        height: 100%;
        .project-item {
          width: 100%;
          height: 100px;
          padding: 32px 60px;
          font-family:Source Han Sans CN;
          color:#ffffff;
          font-size:36px;
        }
      }
    }
  }
</style>
